import $api from '../../utils/api.js'

const login = {
    namespaced: true,
    state: {
        status: '',
        token: localStorage.getItem('token') || '',
        user : JSON.parse(localStorage.getItem("user") || null),
        user_login : [],
        errors:[],
        errors_login:[],
        menu:true,
      },
      mutations: {
        auth_request(state){
          state.status = 'loading'
        },
        auth_success(state, user){
          state.status = 'success'
          state.token = user.token
          state.user = user.user
          state.icons = user.icons
        },
        auth_error(state){
          state.status = 'error'
        },
        logout(state){
          state.status = ''
          state.token = ''
        },
        SET_ERRORS(state, payload) {
          state.errors = payload
        },
        SET_ERRORS_LOGIN(state, payload) {
          state.errors_login = payload
        },
        CHANGE_MENU(state, payload) {
          state.menu = payload
        },
      },
      actions: {
        login({commit}, user){
          return new Promise((resolve, reject) => {
            commit('auth_request')
            $api.post('/login', user)
            .then(resp => {
              const user = {
                token : resp.data.token,
                user : resp.data.user,
              }
    
              localStorage.setItem('token', resp.data.token)
              localStorage.setItem('user', JSON.stringify(resp.data.user))
              $api.defaults.headers.common['Authorization'] = `Bearer ${ resp.data.token }`
              commit('auth_success', user)
              resolve(resp)
            })
            .catch(error => {
              commit('auth_error')
              commit('SET_ERRORS_LOGIN', error.response.data)
              localStorage.removeItem('token')
              localStorage.removeItem('user')
              reject(error)
            })
          })
        },
        logout({commit, state}){
          return new Promise((resolve) => {
            commit('logout')
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            state.user = []
            state.token = ''
            delete $api.defaults.headers.common['Authorization']
            resolve()
          })
        },
      },
      getters : {
        isLoggedIn: state => !!state.token,
        authLevel: state => state.user.level,
        authStatus: state => state.status,
      },
}

export default login